import script from "./SiteMap.vue?vue&type=script&lang=ts&setup=true"
export * from "./SiteMap.vue?vue&type=script&lang=ts&setup=true"

import "./SiteMap.vue?vue&type=style&index=0&id=849e4bc2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-849e4bc2"]])

export default __exports__